export default "__VITE_ASSET__DMj80dtR__"